import { useMutation } from '@tanstack/react-query';
import type { ErrorMessage, InitiatedCartPaymentDto, PayCartV8Request } from '../../../generated-api';
import { useApiClient } from '../../api';
import { parseError } from '../../utils/error-handler';

export const useMutateCartPayV3 = () => {
  const apiClient = useApiClient();
  return useMutation<InitiatedCartPaymentDto, ErrorMessage, PayCartV8Request>({
    mutationFn: async (payCartRequest: PayCartV8Request) => {
      return apiClient.SubmitCartControllerApi.payCartV8(payCartRequest, {
        headers: { 'Content-type': 'application/json' },
      }).catch(parseError);
    },
    mutationKey: ['cart-pay'],
    throwOnError: true,
  });
};
